import React from "react";
import {  FormProvider } from "react-hook-form";
import { Select } from "@components/form";
import { useMemberExcelRegist } from "@hooks";
const MemberExcelRegist = () => {
    const {
        methods, handleFormSubmit, previewData, saveData,
        handleSampleDownload, companyList,
    } = useMemberExcelRegist();

  return (
    <FormProvider {...methods}>
    <div className="contents-wrap">
        <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>회원 일괄 등록[엑셀]</h2>
        </div>

        <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
                <form onSubmit={handleFormSubmit}>
                    <table className="table-list" style={{ width: "100%", marginBottom: "20px" }}>
                        <tbody>
                        <tr>
                            <td  style={{ textAlign: "left" }}>
                            1. 회원 등록 샘플 양식을 다운로드 받아 작성한 후 업로드 하십시오.
                            </td>
                        </tr>
                        <tr>
                            <td  style={{ textAlign: "left" }}>
                            2. 소속 업체를 선택 후 미리 보기 클릭 후 엑셀 에서 읽어 온 회원 정보를 확인 하세요.
                            </td>
                        </tr>
                        <tr>
                            <td  style={{ textAlign: "left" }}>
                            3. 업로드 된 회원 정보를 확인한 후 등록하기 버튼을 클릭하면 회원 등록이 완료됩니다.
                            </td>
                        </tr>
                        <tr>
                            <td  style={{ textAlign: "left", color:"red" }}>
                            <small> * 엑셀 입력 양식 - 성별 : 남성 M, 여성 F , 생년월일 : 2020-02-04, 전화번호 : xxx-xxxx-xxxx, 이메일 : xx@xxx <br/> 최종 저장시 아이디는 이메일, 비밀번호는 <strong>akxhtm(한글:아토스)</strong> 로 일괄 저장 됩니다. </small>
                            <br/>
                            <br/>(양식을 지키지 않으면 업로드가 되지 않습니다.)
                            </td>
                        </tr>
                        <tr>
                            <td >
                            <div style={{ display: "flex",  gap:"20px" }}>
                                <input type="file" id="uploadFile" name="file" className="input-customtext" {...methods.register("file")} />
                                <small style={{ display: "flex", alignItems:"center" }}>먼저 샘플양식을 다운로드하세요. 복수 시트는 지원하지 않습니다.</small>
                            </div>
                            </td>
                        </tr>
                        <tr>
                        <td>
                            <Select
                                name="bizRegNo"
                                options={companyList?.result}
                                valueKey="bizRegNo"  
                                labelKey="companyNm"
                                defaultOption="전체" 
                                className="input-select"
                                style={{width:"200px", display:"flex"}}
                            />
                        </td>
                        </tr>
                        </tbody>
                    </table>

                    <div className="btn-right-box" style={{ marginBottom: "20px" }}>
                        <ul>
                        <li>
                            <button
                            type="button"
                            className="btn-excel"
                            onClick={handleSampleDownload}
                            >
                            샘플양식 다운로드
                            </button>
                        </li>
                        <li>
                            <button
                            type="submit"
                            className="btn-write"
                            id="preview"
                            >
                            미리보기
                            </button>
                        </li>
                        <li>
                            <button
                            type="button"
                            className="btn-write"
                            id="save"
                            onClick={saveData}
                            >
                            등록
                            </button>
                        </li>
                        </ul>
                    </div>

                    <div className="table-container">
                        <table className="table-list" style={{ width: "100%" }}>
                        <colgroup>

                        </colgroup>
                        <thead>
                            <tr>
                                <th>이름</th>
                                <th>성별</th>
                                <th>생년월일</th>
                                <th>전화번호</th>
                                <th>이메일</th>
                                <th>부서</th>
                                <th>직급</th>
                            </tr>
                        </thead>
                        <tbody>
                        {previewData.length > 0 ? (
                            previewData.map((row, index) => (
                                <tr key={index}>
                                <td>{row.memberNm}</td>
                                <td>{row.genderCd === 'M' ? '남자' : row.genderCd === 'F' ? '여자' : ''}</td>
                                <td>{row.birthDt}</td>
                                <td>{row.phoneNo}</td>
                                <td>{row.email}</td>
                                <td>{row.departmentNm}</td>
                                <td>{row.positionNm}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center" }}> 업로드한 데이터가 없습니다.  </td>
                            </tr>
                        )}
                        </tbody>
                        </table>
                    </div>
                </form>
            </div>
        </div>
    </div>
    </FormProvider>
      
  );
};

export { MemberExcelRegist };
